import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { ELEMENTS_GUI_FIELDS } from "./elements.settings";

const { "Thème & Couleurs": THEME, ...REST } = ELEMENTS_GUI_FIELDS;

export const X_ICON_GUI_FIELDS: TXGUISection = {
  Données: [{ type: "icon", name: "icon", label: "Nom de L'icon" }],
  "Thème & Couleurs": [
    ...(THEME ?? []),
    {
      type: "color",
      name: "color",
      label: "Couleur du texte",
      defaultValue: "#000000",
    },
    {
      type: "sizing",
      name: "fontSize",
      label: "Taille de la police",
      placeholder: "10",
      units: ["px", "em", "rem", "pt"],
    },
    {
      type: "select_option",
      name: "fontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 400,
    },
  ],
  Survolés: [
    {
      type: "color",
      name: "hoverColor",
      label: "Couleur du texte",
    },
    {
      type: "sizing",
      name: "hoverFontSize",
      label: "Taille de la police",
      placeholder: "10",
      units: ["px", "em", "rem", "pt"],
    },
  ],
  ...REST,
};

// {
//   type: "select_option",
//   name: "href",
//   label: "Naviger vers",
//   options: [
//     { value: "NONE", label: "Aucune Page" },
//     { value: "/", label: "Page d'Accueil" },
//     { value: "/shop", label: "Page Boutique" },
//     { value: "/categories/[slug]", label: "Page Categorie" },
//     { value: "/about-us", label: "Page A Propos de nous" },
//     { value: "/contact-us", label: "Page Contactez-nous" },
//     { value: "/blog", label: "Page Blog" },
//     { value: "/blog/[slug]", label: "Page Blog Article" },
//     { value: "/checkout", label: "Page Payement" },
//     { value: "/products/[slug]", label: "Page Detail du Produit" },
//   ],
//   defaultValue: "NONE",
// },
